<div class="row mt-1 p-1">
  <div class="col-xs-6">
    <span class="span-title-total-balance">Saldo Geral:</span>
  </div>
  <div class="col-xs-6 text-right">
    <span class="span-amount-total-balance">R$ </span>
    <span *ngIf="!loading" class="span-amount-total-balance">{{
      amount
        | mask
          : "separator.2"
          : { thousandSeparator: ".", decimalMarker: ",", leadZero: true }
    }}</span>
    <div *ngIf="loading" class="spinner-inline"></div>
  </div>
</div>
<div class="row mt-3 p-1">
  <div class="col-xs-6">
    <span class="span-title-unavailable-balance">Saldo Bloqueado: </span>
  </div>
  <div class="col-xs-6 text-right">
    <small class="span-amount-unavailable-balance">R$ </small>
    <small *ngIf="!loading" class="span-amount-unavailable-balance">{{
      blockedAmount | mask : "separator.2" : { thousandSeparator: "." }
    }}</small>
    <div *ngIf="loading" class="spinner-inline"></div>
  </div>
</div>
<div class="row mt-3 p-1">
  <div class="col-xs-6">
    <span class="span-title-available-balance">Saldo Disponível:</span>
  </div>
  <div class="col-xs-6 text-right">
    <span class="span-amount-available-balance">R$ </span>
    <span *ngIf="!loading" class="span-amount-available-balance">{{
      readyAmount | mask : "separator.2" : { thousandSeparator: "." }
    }}</span>
    <div *ngIf="loading" class="spinner-inline"></div>
  </div>
</div>
